import i18n from '@/utils/i18n';
import { AllowedShortcuts } from '@/platform/shortcuts/operator-shortcuts';
import { SalesPortalShortcuts } from '@/experiences/sales-portal/platform/shortcuts/sales-portal-shortcuts';

/**
 * Get the display title for a shortcut key
 * Accepts string to support shortcuts from any experience
 */
export const getShortcutTitle = (pressedKey: string | string[]): string => {
  if (Array.isArray(pressedKey)) {
    return i18n.t('keyboard_shortcuts.shortcut.specific_item');
  }

  switch (pressedKey) {
    case AllowedShortcuts.AddNote:
      return i18n.t('keyboard_shortcuts.shortcut.add_note');
    case AllowedShortcuts.ArrowDown:
    case AllowedShortcuts.ArrowUp:
      return i18n.t('keyboard_shortcuts.shortcut.up_down_list');
    case AllowedShortcuts.PlaceOrder:
      return i18n.t('keyboard_shortcuts.shortcut.place_order');
    case AllowedShortcuts.Search:
      return i18n.t('keyboard_shortcuts.shortcut.search');
    case AllowedShortcuts.SwitchExperience:
      return i18n.t('keyboard_shortcuts.shortcut.switch_experience');
    case AllowedShortcuts.ToggleCart:
      return i18n.t('keyboard_shortcuts.shortcut.toggle_cart');
    case AllowedShortcuts.ToggleKeyboardShortcutsModal:
      return i18n.t('keyboard_shortcuts.shortcut.toggle_shortcuts_modal');
    case AllowedShortcuts.ToggleLocationPicker:
      return i18n.t('keyboard_shortcuts.shortcut.toggle_location_picker');
    case AllowedShortcuts.ToggleSalesRepMode:
      return i18n.t('keyboard_shortcuts.shortcut.toggle_sales_rep_mode');
    case AllowedShortcuts.ViewRestaurantAccount:
      return i18n.t('keyboard_shortcuts.shortcut.view_restaurant_account');
    // Sales Portal shortcuts
    case SalesPortalShortcuts.SwitchBuildReviewMode:
      return i18n.t(
        'keyboard_shortcuts.shortcut.sales_portal.switch_build_review_mode',
      );
    case SalesPortalShortcuts.SwitchExperience:
      return i18n.t(
        'keyboard_shortcuts.shortcut.sales_portal.switch_experience',
      );
    case SalesPortalShortcuts.ToggleCheckout:
      return i18n.t('keyboard_shortcuts.shortcut.toggle_cart');
    default:
      return i18n.t('keyboard_shortcuts.shortcut.unknown_shortcut_action', {
        pressedKey,
      });
  }
};
